export default "__VITE_ASSET__b7b64c97__"